import { useState } from 'react'
import { TbCameraUp } from 'react-icons/tb'

export default function ImageInput({ id, onChange, defaultValue, className }) {
  const [selectedImage, setSelectedImage] = useState(defaultValue)
  function handleOnChangeImage(event) {
    if (event.target.files[0]) {
      setSelectedImage(URL.createObjectURL(event.target.files[0]))
      onChange(event.target.files[0])
    } else {
      setSelectedImage(defaultValue)
      onChange(null)
    }
  }

  return (
    <>
      {selectedImage ? (
        <div
          className={`relative h-64 w-64 border-2 border-muted-500 ${className}`}
        >
          <img
            className="h-full w-full object-contain"
            src={selectedImage}
            alt="file uploader"
          />
          <label
            htmlFor={id}
            className="absolute right-2 top-2 cursor-pointer bg-primary-600 px-4 py-1 text-white hover:bg-accent-600"
          >
            تغيير
          </label>
        </div>
      ) : (
        <label
          className={`flex h-64 w-64 cursor-pointer items-center justify-center border-2 border-muted-500 text-muted-500 hover:border-primary-600 hover:text-primary-600 ${className}`}
          htmlFor={id}
        >
          <TbCameraUp
            className=""
            size={64}
            strokeWidth={0.71}
          />
        </label>
      )}
      <input
        accept="image/webp"
        onChange={handleOnChangeImage}
        className="hidden"
        type="file"
        name=""
        id={id}
      />
    </>
  )
}
